import styled from "@emotion/styled";

import { theme, ZIndexLayer } from "shared/lib/styles";

import { Share } from "scmp-app/components/article/article-2.0-action-widget/share";
import {
  Container as ShareContainer,
  StyledIconShare,
} from "scmp-app/components/article/article-2.0-action-widget/share/styles";
import {
  StyledContentShareWidget,
  StyledDynamicDrawer,
} from "scmp-app/components/content/content-share-widget-drawer/styles";
import { EntityLink } from "scmp-app/components/entity-link";
import {
  AdContainer,
  AdControlButtonContainer,
  StyledYouTube,
  Container as YoutubePlayerContainer,
  VideoContainer as YoutubePlayerVideoContainer,
} from "scmp-app/components/scmp-youtube-video/scmp-youtube-video-player/styles";

import MuteIcon from "./mute.svg?url";
import RedirectIcon from "./redirect.svg?url";
import ShareIcon from "./share.svg?url";
import UnMuteIcon from "./unmute.svg?url";

const ArticleShareWidget = styled(StyledContentShareWidget)``;

const ShareDynamicDrawer = styled(StyledDynamicDrawer)``;

export const Container = styled("div", {
  shouldForwardProp: property => property !== "$isActive",
})<{ $isActive?: boolean }>`
  position: relative;

  inline-size: 100vw;
  block-size: calc(100dvh - 67px);

  ${YoutubePlayerContainer} {
    border-radius: 12px;

    overflow: hidden;
  }

  ${theme.breakpoints.up("tablet")} {
    inline-size: 506px;
    block-size: 80vh;
    max-block-size: 900px;
  }

  iframe,
  ${YoutubePlayerContainer}, ${YoutubePlayerVideoContainer}, ${StyledYouTube} {
    inline-size: 100% !important;
    block-size: 100%;
    /* aspect-ratio: 375/667; */
    aspect-ratio: 9/16;

    ${theme.breakpoints.up("tablet")} {
      inline-size: 506px !important;
      aspect-ratio: 506/900;
    }
  }

  /* Add overlay to allow swipe on non-active slides */
  ${props =>
    !props.$isActive &&
    `
    &::before {
      content: '';
      position: absolute;
      inset: 0;
      z-index: ${ZIndexLayer.Modal + 2};
      background: transparent;
      pointer-events: auto;
    }

    iframe {
      pointer-events: none;
    }
  `}

  ${ShareDynamicDrawer} {
    z-index: ${ZIndexLayer.Modal + 20};
  }

  ${AdContainer} {
    z-index: ${ZIndexLayer.Modal + 2};
  }

  ${AdControlButtonContainer} {
    inset-block: auto 16px;
    inset-inline: 16px auto;
    z-index: ${ZIndexLayer.Modal + 3};
  }
`;

export const PlayerContainer = styled.div<{ $isActive: boolean }>`
  inline-size: 100%;
  block-size: 100%;

  filter: ${props => (props.$isActive ? "none" : "brightness(0.7)")};
`;

export const PlayerOverlay = styled.div`
  position: absolute;
  inset: 0;
  z-index: ${ZIndexLayer.Modal + 1};
`;

export const StyledShareButton = styled(Share)``;

export const ShareButton = styled.button`
  inline-size: 32px;
  block-size: 32px;

  background-color: transparent;
  background-image: url(${ShareIcon});
  background-repeat: no-repeat;
  background-size: cover;

  cursor: pointer;
`;

export const MuteButton = styled.button<{ $unmute: boolean }>`
  inline-size: 32px;
  block-size: 32px;

  background-color: transparent;
  background-image: url(${props => (props.$unmute ? UnMuteIcon : MuteIcon)});
  background-repeat: no-repeat;
  background-size: cover;

  cursor: pointer;
`;

export const RedirectButton = styled(EntityLink)`
  inline-size: 32px;
  block-size: 32px;

  background-color: transparent;
  background-image: url(${RedirectIcon});
  background-repeat: no-repeat;
  background-size: cover;

  cursor: pointer;
`;

export const CloseButton = styled.button`
  position: absolute;
  inset-block-start: 20px;
  inset-inline-start: 20px;
  z-index: ${ZIndexLayer.Modal + 3};

  display: flex;
  justify-content: center;
  align-items: center;

  inline-size: 32px;
  block-size: 32px;
  padding: 7px;

  border-radius: 100px;

  background: rgba(0, 0, 0, 0.7);

  cursor: pointer;
  ${theme.breakpoints.up("tablet")} {
    display: none;
  }
`;

export const TitleOverlay = styled.div`
  position: absolute;
  inset-block-end: 0;
  inset-inline: 0;
  z-index: 1;

  padding: 16px;
  padding-inline-end: 60px;

  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000000 100%);
`;

export const TitleText = styled.p`
  color: #ffffff;
  font-weight: 400;
  font-size: 14px;
  font-family: Roboto;
  font-style: normal;
  line-height: normal;
`;

export const ButtonContainer = styled.div`
  position: absolute;
  inset-block-end: 16px;
  inset-inline-end: 16px;
  z-index: 2;

  display: flex;
  flex-direction: column;
  gap: 16px;

  ${theme.breakpoints.up("tablet")} {
    inset-block-end: 0;
    inset-inline-end: -52px;
  }

  ${StyledIconShare}, ${StyledIconShare}:hover {
    inline-size: 32px;
    block-size: 32px;

    border-radius: 100%;

    background-color: rgba(0, 0, 0, 0.7) !important;

    fill: rgba(0, 0, 0, 0.7);

    rect,
    rect:hover {
      stroke: rgba(0, 0, 0, 0.7);
    }

    path {
      fill: #ffffff;
    }
  }

  ${ShareContainer} {
    inline-size: 32px;
    block-size: 32px;
  }

  ${StyledContentShareWidget} {
    svg {
      path {
        fill: transparent !important;
      }
    }
  }

  ${ArticleShareWidget} {
    svg {
      path:last-child {
        fill: transparent !important;
      }
    }
  }
`;
